import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'courses',
    label: 'Course',
    service: typedResourceService('Course'),
})

export const { appendResource: appendCourse, destroyResource: destroyCourse, changeResource: changeCourse } = actions
export const { initializeResources: initializeCourses, deleteResource: deleteCourse, searchResources: searchCourses, refreshResource: refreshCourse } = thunks

// Children travel inline on the parent payload; the backend reconciles them by omission.
export const createCourse = (data, list) => thunks.createResource({ ...data, sub_courses: list || [] })

export const updateCourse = (id, data, courses, admin) => thunks.updateResource(id, { ...data, sub_courses: courses }, admin)

export default reducer
